// extracted by mini-css-extract-plugin
export var resizer = "_hv-0";